import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetSmsDraft(club) {

  var url = "/sms_api/get_sms_reservation_draft/" + club;
  return FetchGetDataWithAuthNEW(url);
}